import { render } from "./CloseBlack.vue?vue&type=template&id=69846c78"
import script from "./CloseBlack.vue?vue&type=script&lang=js"
export * from "./CloseBlack.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__